export const busScheduleStatusList = [
  { id: "done", name: "Done", color: "#4caf50" },
  { id: "not_done", name: "Not Done", color: "#f44336" },
];

export const invoiceStatusList = [
  { id: "done", name: "Done", color: "#4caf50" },
  { id: "not_done", name: "Not Done", color: "#f44336" },
];

export const statusList = [
  { id: "approved", name: "Approved", color: "#1976d2" },
  { id: "pending", name: "Pending", color: "#ff9800" },
  { id: "completed", name: "Completed", color: "#4caf50" },
  { id: "cancelled", name: "Cancelled", color: "#f44336" },
];

export const formTypeList = [
  { id: "cancel_service", name: "Cancel Service", color: "#009688" },
  { id: "change_address", name: "Change Address", color: "#795548" },
  { id: "change_service", name: "Change Service", color: "#7c4dff" },
  { id: "new_student", name: "New Student", color: "#40c4ff" },
];

export const busScheduleStatusFilterList = [
  { id: "Done", name: "Done" },
  { id: "NotDone", name: "Not Done" },
];

export const invoiceStatusFilterList = [
  { id: "Done", name: "Done" },
  { id: "NotDone", name: "Not Done" },
];

export const statusFilterList = [
  { id: "Approved", name: "Approved" },
  { id: "Pending", name: "Pending" },
  { id: "Completed", name: "Completed" },
  { id: "Cancelled", name: "Cancelled" },
];

export const formTypeFilterList = [
  { id: "CancelService", name: "Cancel Service" },
  { id: "ChangeAddress", name: "Change Address" },
  { id: "ChangeService", name: "Change Service" },
  { id: "NewStudent", name: "New Student" },
];

export const changeRequestFormLogType = [
  { id: "bus_schedule_status", name: "Routeplanner Role Status" },
  {
    id: "invoice_status",
    name: "Customer Service Role Status",
  },
  { id: "change_request_status", name: "Change Request Form Status" },
];
